var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('card',[_c('IVRKeys',{attrs:{"initial-i-v-r":_vm.initialIVR},on:{"button-add":_vm.loadInternal,"button-remove":_vm.loadInternal}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }